<div class="card menus menu-bar">
    <div class="align-items-center d-flex h-100 justify-content-around">
        <span class="menu-bar-content" (click)="commonService.navigateToPage('/home')">
            <img [src]="isActive( '/home')? commonService.resource.image.menu.home_selected :commonService.resource.image.menu.home" alt="home">
            <div>{{'menuBar.peerChat' | translate}} </div>
        </span>
        <span class="menu-bar-content" (click)="commonService.navigateToPage('/safety-plan')">
            <img [src]="isActive( '/safety-plan')? commonService.resource.image.menu.safety_plan_selected :commonService.resource.image.menu.safety_plan" alt="safety plan">
            <div>{{'menuBar.safetyPlan' | translate}}</div>
        </span>
        <span class="menu-bar-content" (click)="commonService.navigateToPage('/self-care')">
            <img [src]="isActive( '/self-care')? commonService.resource.image.menu.self_care_selected : commonService.resource.image.menu.self_care" alt="self care ">
            <div>{{'menuBar.selfCare' | translate}}</div>
        </span>
        <span class="menu-bar-content " (click)="commonService.navigateToPage( '/resource') ">
            <img [src]="isActive( '/resource')? commonService.resource.image.menu.resource_selected : commonService.resource.image.menu.resource " alt="resource ">
            <div>{{'menuBar.resources' | translate}}</div>
        </span>
        <span class="menu-bar-content " (click)="commonService.navigateToPage( '/menu') ">
            <img [src]="isActive( '/menu')? commonService.resource.image.menu.menu_selected :commonService.resource.image.menu.menu " alt="menu ">
            <div>{{'menuBar.more' | translate}}</div>
        </span>
    </div>
</div>